import { render } from "./TimetableBox.vue?vue&type=template&id=f7cff18e&scoped=true"
import script from "./TimetableBox.vue?vue&type=script&lang=js"
export * from "./TimetableBox.vue?vue&type=script&lang=js"

import "./TimetableBox.vue?vue&type=style&index=0&id=f7cff18e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7cff18e"]])

export default __exports__